var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"allproduct-parent"}},[_c('span',{attrs:{"id":"sideFilter-desktop"}},[_c('sideFilter')],1),_c('span',{attrs:{"id":"product-grid-allproduct"}},[_c('productGrid')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }